import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../Shared/Icon/Icon'

const EmptyTable = ({ clearFilters }) => (
  <div>
    <div className="container__actions">
      <span className="container-actions__action" onClick={clearFilters}>
        <Icon type="filter" />
        Clear filters
      </span>
    </div>
    <div className="no-conversations-message">
      <span>
        <Icon type={['far', 'envelope-open']} className="u-mr10" />
        There are no messages...
      </span>
    </div>
  </div>
)

EmptyTable.propTypes = {
  clearFilters: PropTypes.func.isRequired,
}

export default EmptyTable
